import { render, staticRenderFns } from "./Title_Counter.vue?vue&type=template&id=53af8992&scoped=true&"
import script from "./Title_Counter.vue?vue&type=script&lang=js&"
export * from "./Title_Counter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53af8992",
  null
  
)

export default component.exports